import { GridFilterOperators } from '@progress/kendo-react-grid';

const FilterOperators: GridFilterOperators = {
  text: [
    { text: 'grid.filterContainsOperator', operator: 'contains' },
    { text: 'grid.filterEqOperator', operator: 'eq' },
  ],
  numeric: [
    { text: 'grid.filterEqOperator', operator: 'eq' },
    { text: 'grid.filterLteOperator', operator: 'lte' },
    { text: 'grid.filterGteOperator', operator: 'gte' },
  ],
  date: [
    { text: 'grid.filterAfterOrEqualOperator', operator: 'gte' },
    { text: 'grid.filterBeforeOrEqualOperator', operator: 'lte' },
    { text: 'grid.filterEqOperator', operator: 'eq' },
  ],
  boolean: [{ text: 'grid.filterEqOperator', operator: 'eq' }],
};

export default FilterOperators;
